import { render, staticRenderFns } from "./feedFilter.vue?vue&type=template&id=47135484"
import script from "./feedFilter.vue?vue&type=script&lang=js"
export * from "./feedFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports